import type { ChipSize } from '@/core/components/chip/chip';
import type { QuickFilterGroup } from '@/features/filter/quick-filter/quick-filter-service';

import Chip from '@/core/components/chip/chip';
import usePendingState from '@/core/features/render/use-pending-state';
import { isFilterSingleMandatory } from '@/features/filter/filter-data/service/filter-data-service';

type QuickFilterChipProps = {
    closeButtonSize?: number;
    group: QuickFilterGroup;
    largeIcons?: boolean;
    onDeselect: (group: QuickFilterGroup) => void;
    onSelect: (group: QuickFilterGroup) => void;
    rounded?: boolean;
    size?: ChipSize;
};

export default function QuickFilterChip({
    closeButtonSize,
    group,
    largeIcons = false,
    onDeselect,
    onSelect,
    rounded = true,
    size = 'normal',
}: QuickFilterChipProps) {
    const { hasSelectedFilterOptions, selectedQuickFilterTitle, type } = group;
    const [pendingState, setPendingState] = usePendingState<boolean>(2000, selectedQuickFilterTitle);

    const isSingleMandatory = isFilterSingleMandatory(type);

    const isActive = pendingState !== null ? pendingState : hasSelectedFilterOptions || isSingleMandatory;
    const isClosable = hasSelectedFilterOptions && !isSingleMandatory;
    const isExtendable = !hasSelectedFilterOptions || isSingleMandatory;

    const _onDeselect = () => {
        setPendingState(!isActive);
        onDeselect(group);
    };
    return (
        <Chip
            active={isActive}
            closeButtonSize={closeButtonSize}
            closeable={isClosable}
            extendable={isExtendable}
            key={selectedQuickFilterTitle}
            largeIcons={largeIcons}
            onClick={() => onSelect(group)}
            onDeselect={_onDeselect}
            qaId={'qa-quick-filter-chip'}
            rounded={rounded}
            size={size}
        >
            {selectedQuickFilterTitle}
        </Chip>
    );
}
